// import React, {useEffect, useState} from 'react'
import React from 'react'
import './index.less'
import {BasicShowCard} from '../BasicShowCard';
import {
    cyanDetailStat, cyanPracticeOnlineStat,
    SHOW_CONTAINER_DESCRIPTION,
    URL_CY_PRACTICE, URL_CY_PRACTICE_WAP, URL_STATIC_HELP
} from '../../../../constants/CyHomepage'
import Button from "../../../../components/Button";

import {diffEndJump} from "../../../../utils/tools";
import CyBaseShowImage from "../../../../assets/images/cy/cy-base-show.png";



const clsPrefix = 'c-our-show'
const ShowContainer: React.FC<{
    isInScreen: boolean
}> = ({
          isInScreen = true
      }) => {
    return (
        <div className={clsPrefix}>
            <div className={`${clsPrefix}-container`}>
                <div className={`${clsPrefix}__left`}>

                    <div className='description-cards'>
                        {
                            SHOW_CONTAINER_DESCRIPTION.map((item, index) => (
                                <div className={`description-card`}>
                                    <BasicShowCard
                                        key={index}
                                        title={item.title}
                                        descriptions={item.descriptions}
                                        iconStyle={item.iconStyle}
                                    />
                                </div>
                            ))
                        }

                        <div className='description-btn'>
                            <div className='opt-btn'>
                                <Button
                                    type='default'
                                    onClick={() => {
                                        // @ts-ignore
                                        window.xqui.useStat({
                                            category: cyanDetailStat.category,
                                            page: 'cy_pc_homepage',
                                            bizType: 5,
                                            action: 'click'
                                        })
                                        diffEndJump({ href: URL_STATIC_HELP, wapHref: URL_STATIC_HELP })
                                    }}
                                >
                                    详情介绍
                                </Button>
                                <Button type='primary' onClick={() => {
                                    // @ts-ignore
                                    if (window && window.xqui && window.xqui.useStat) {
                                        // @ts-ignore
                                        window.xqui.useStat({
                                            category: cyanPracticeOnlineStat.category,
                                            page: 'cy_pc_homepage',
                                            bizType: 5,
                                            action: 'click',
                                        })
                                    }
                                    diffEndJump({ href: URL_CY_PRACTICE, wapHref: URL_CY_PRACTICE_WAP })
                                }}>
                                    在线体验
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${clsPrefix}__right`}>
                    <img className='showImg' src={CyBaseShowImage}/>
                </div>
            </div>
        </div>
    )
}
export { ShowContainer }
